// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionD_comp__y9UVx","section":"SectionD_section__USWF5","btn_container":"SectionD_btn_container__C1cn_","btn":"SectionD_btn__RngOr","ef-box":"SectionD_ef-box__zVo_w"};